import { AxiosError } from 'axios';
import { QueryConfig, useQuery } from 'react-query';

import { DbQuestion } from '~src/types/db';
import { QueryKeys } from './queryKeys';
import {
  getQuestionsList,
  GetQuestionsListParams,
  getPendingQuestionsCount,
} from '~src/services/api/questions';

export const useQuestions = (
  params: GetQuestionsListParams,
  queryConfig: QueryConfig<
    { questions: DbQuestion[]; totalCount: number },
    AxiosError
  > = {}
) => {
  const { enabled, ...options } = queryConfig;

  const enabledOverride = enabled || enabled === undefined;

  const filesQuery = useQuery([QueryKeys.question, params], getQuestionsList, {
    enabled: enabledOverride && params.projectId && params.tenderId,
    ...options,
  });

  return filesQuery;
};

export const usePendingQuestionsCount = (
  params: { projectId?: number; tenderId: string },
  options: QueryConfig<number, AxiosError> = {}
) =>
  useQuery(
    [QueryKeys.questionsPendingCount, params],
    () =>
      getPendingQuestionsCount(
        params as { projectId: number; tenderId: string }
      ),
    {
      enabled: !!params.projectId && !!params.tenderId,
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
      ...options,
    }
  );
